var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Navbar'),_c('v-main',{staticClass:"ma-4"},[_c('router-view')],1),_c('Footer'),_c('notifications',{attrs:{"group":"foo","position":"bottom right","classes":"custom-notification","width":"500","speed":400}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }